import { useEffect, useState } from "react";
import styles from "../add.module.css";
import { Delete } from "@mui/icons-material";
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import { authData } from "../../../../admin/components/GetAuth";

const ProductComponent = ({ fields, append, errors, control, setValue, register, clearErrors, watch, cngProductVal, delItems, calculateDimension, freightType }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [productList, setProductList] = useState([]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/product-dd-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                let allData = response.data.data;
                allData = allData.concat([{ id: 0, title: 'Other' }, { id: -1, title: 'Other With Dimension' }]);
                setProductList(allData);
            }
        });
    }, [API_TOKEN]);

    return (
        <div>
            <div className={styles.ItemsList}>
                {fields?.map((item, index) => {
                    const categoryId = watch(`products[${index}].category_id`);
                    const isDimensioned = categoryId === -1;
                    const isFragile = watch(`products[${index}].is_fragile`);

                    return (
                        <div
                            className={`${styles.ItemCard} ${isFragile ? styles.ItemCardFragile : ""}`}
                            key={item.id}
                        >
                            <div className={styles.ItemCardHeader}>
                                <div className={styles.ItemCardLabelGroup}>
                                    <span className={styles.ItemBadge}>{String(index + 1).padStart(2, "0")}</span>
                                    <span className={styles.ItemCardLabel}>Item {index + 1}</span>
                                </div>
                                <button
                                    className={styles.ItemDeleteBU}
                                    type="button"
                                    disabled={fields.length <= 1}
                                    onClick={() => delItems(index)}
                                    aria-label="Remove item"
                                >
                                    <Delete />
                                </button>
                            </div>

                            <div className={styles.ItemFieldsRow}>
                                <div className={styles.ItemField}>
                                    <FormControl fullWidth>
                                        <InputLabel>Category*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].category_id`, { required: true })}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    label="Category*"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        if (e.target.value) {
                                                            if (e.target.value === -1) {
                                                                setValue(`products[${index}].item_id`, 0);
                                                            } else {
                                                                let selCat = productList?.filter((i) => i?.id === e.target.value);
                                                                if (selCat.length) {
                                                                    selCat = selCat[0];
                                                                    if (selCat?.no_of_child === 0) {
                                                                        setValue(`products[${index}].item_id`, selCat?.id);
                                                                        setValue(`products[${index}].item_name`, selCat?.title);
                                                                        setValue(`products[${index}].total`, selCat?.amount);
                                                                        setValue(`products[${index}].is_fragile`, selCat?.is_fragile === 1);
                                                                        setValue(`products[${index}].is_item`, false);
                                                                    } else {
                                                                        setValue(`products[${index}].item_id`, "");
                                                                        setValue(`products[${index}].item_name`, "");
                                                                        setValue(`products[${index}].total`, "");
                                                                        setValue(`products[${index}].is_fragile`, false);
                                                                        setValue(`products[${index}].is_item`, true);
                                                                    }
                                                                    clearErrors();
                                                                }
                                                                cngProductVal();
                                                            }
                                                        } else {
                                                            setValue(`products[${index}].item_id`, 0);
                                                        }
                                                    }}
                                                >
                                                    {productList?.map((val) => (
                                                        (val?.parent_id === 0 || val?.id === 0 || val?.id === -1) ? (
                                                            <MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>
                                                        ) : null
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                    {errors?.products?.length > 0 && errors?.products[index]?.category_id && (
                                        <p className={styles.ErrorM}>Please select category</p>
                                    )}
                                </div>

                                <div className={styles.ItemField}>
                                    {(categoryId === 0 || categoryId === -1) && (
                                        <>
                                            <Controller
                                                key={item.id}
                                                control={control}
                                                {...register(`products[${index}].item_name`, { required: true })}
                                                render={({ field }) => (
                                                    <TextField {...field} label="Product*" variant="outlined" fullWidth />
                                                )}
                                            />
                                            {errors?.products?.length > 0 && errors?.products[index]?.item_name && (
                                                <p className={styles.ErrorM}>Please select item</p>
                                            )}
                                        </>
                                    )}
                                    {(watch(`products[${index}].is_item`) && categoryId !== 0 && categoryId !== -1) && (
                                        <>
                                            <FormControl fullWidth>
                                                <InputLabel>Item*</InputLabel>
                                                <Controller
                                                    key={item.id}
                                                    control={control}
                                                    {...register(`products[${index}].item_id`, { required: true })}
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            label="Item*"
                                                            onChange={(e) => {
                                                                field.onChange(e);
                                                                if (e.target.value) {
                                                                    let selProduct = productList?.filter((i) => i?.id === e.target.value);
                                                                    if (selProduct.length) {
                                                                        selProduct = selProduct[0];
                                                                        setValue(`products[${index}].item_name`, selProduct?.parent?.title + "- " + selProduct?.title);
                                                                        setValue(`products[${index}].total`, selProduct?.amount);
                                                                        setValue(`products[${index}].is_fragile`, selProduct?.is_fragile === 1);
                                                                        clearErrors();
                                                                    }
                                                                }
                                                                cngProductVal();
                                                            }}
                                                        >
                                                            {productList?.map((val) => (
                                                                val?.parent_id === categoryId ? (
                                                                    <MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>
                                                                ) : null
                                                            ))}
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                            {errors?.products?.length > 0 && errors?.products[index]?.item_id && (
                                                <p className={styles.ErrorM}>Please select item</p>
                                            )}
                                        </>
                                    )}
                                </div>

                                {isDimensioned && (
                                    <div className={styles.DimensionGroup}>
                                        <div className={styles.ItemFieldSmall}>
                                            <Controller
                                                key={item.id}
                                                control={control}
                                                {...register(`products[${index}].length`, { required: true })}
                                                render={({ field }) => (
                                                    <NumericFormat
                                                        {...field}
                                                        label="Length(cm)*"
                                                        variant="outlined"
                                                        customInput={TextField}
                                                        fullWidth
                                                        allowLeadingZeros={false}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            calculateDimension?.(index);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.products?.length > 0 && errors?.products[index]?.length && (
                                                <p className={styles.ErrorM}>Length required</p>
                                            )}
                                        </div>
                                        <div className={styles.ItemFieldSmall}>
                                            <Controller
                                                key={item.id}
                                                control={control}
                                                {...register(`products[${index}].width`, { required: true })}
                                                render={({ field }) => (
                                                    <NumericFormat
                                                        {...field}
                                                        label="Width(cm)*"
                                                        variant="outlined"
                                                        customInput={TextField}
                                                        fullWidth
                                                        allowLeadingZeros={false}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            calculateDimension?.(index);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.products?.length > 0 && errors?.products[index]?.width && (
                                                <p className={styles.ErrorM}>Width required</p>
                                            )}
                                        </div>
                                        <div className={styles.ItemFieldSmall}>
                                            <Controller
                                                key={item.id}
                                                control={control}
                                                {...register(`products[${index}].height`, { required: true })}
                                                render={({ field }) => (
                                                    <NumericFormat
                                                        {...field}
                                                        label="Height(cm)*"
                                                        variant="outlined"
                                                        customInput={TextField}
                                                        fullWidth
                                                        allowLeadingZeros={false}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            calculateDimension?.(index);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.products?.length > 0 && errors?.products[index]?.height && (
                                                <p className={styles.ErrorM}>Height required</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {freightType === 'Air Freight' && (
                                    <div className={styles.ItemFieldSmall}>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].weight`, { required: true })}
                                            render={({ field }) => (
                                                <NumericFormat
                                                    {...field}
                                                    label="Weight (kg)*"
                                                    variant="outlined"
                                                    customInput={TextField}
                                                    fullWidth
                                                    allowLeadingZeros={false}
                                                    allowNegative={false}
                                                    decimalScale={2}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        cngProductVal();
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors?.products?.length > 0 && errors?.products[index]?.weight && (
                                            <p className={styles.ErrorM}>Weight required</p>
                                        )}
                                    </div>
                                )}

                                <div className={styles.ItemFieldTotal}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].total`, { required: true })}
                                        render={({ field }) => (
                                            <NumericFormat
                                                {...field}
                                                label="Total (£)*"
                                                variant="outlined"
                                                customInput={TextField}
                                                fullWidth
                                                allowLeadingZeros={false}
                                                allowNegative={false}
                                                decimalScale={2}
                                                fixedDecimalScale
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    cngProductVal();
                                                }}
                                            />
                                        )}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.total && (
                                        <p className={styles.ErrorM}>Total required</p>
                                    )}
                                </div>

                                <div className={styles.ItemFieldToggle}>
                                    <FormControlLabel
                                        label="Fragile"
                                        className={`${styles.FragileToggle} ${isFragile ? styles.FragileToggleActive : ""}`}
                                        control={
                                            <Controller
                                                key={item.id}
                                                control={control}
                                                {...register(`products[${index}].is_fragile`)}
                                                render={({ field }) => <Checkbox {...field} checked={!!field?.value} />}
                                            />
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <button
                className={styles.AddItemBU}
                type="button"
                onClick={() => append({ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true })}
            >
                Add item
            </button>
        </div>
    );
}

export default ProductComponent;